<template>
  <div id="app">
    <head-Back></head-Back>
    <div class="page">
      <div class="page-title">打开【OPPO】手机的设置</div>

      <div class="page-title-samll">
        <p>下方举例手机为：OPPO R17</p>
        <p>
          注意：请打开手机的震动响铃模式，因为静音模式和 
          <br />飞行模式会影响消息通知的提示
        </p>
      </div>

      <div class="page-desc">① 打开手机【设置】- 【通知】</div>
      <img src="./img/s-oppo-1.png" />

      <div class="page-desc">②  在设置页面，打开【通知与状态栏】</div>
      <img src="./img/s-oppo-2.png" />

      <div class="page-desc">③  在通知与状态栏页面打开前面两个开关</div>
      <img src="./img/s-oppo-3.png" />

      <div class="page-desc">④  在管理通知页面找到这个APP，打开开关</div>
      <img src="./img/s-oppo-4.png" />

      <div class="page-desc">⑤  打开“允许通知”，“系统默认通道”</div>
      <img src="./img/s-oppo-5.png" />

      <div class="page-title-t">
        这样就打开了oppo手机
        <br />接收这个APP消息的开关
      </div>

      <div class="page-title-samll-t">
        <p>
          oppo手机、不同版本、不同型号，以上设置的位置也可能不同, 具体请根据每个手机进行设置。       
         </p>
      </div>
    </div>
  </div>
</template>
<script>
import headBack from "../common/head-back-close";

export default {
  metaInfo: {
    title: "设置"
  },
  name: "app",
  data() {
    return {
      msg: "设置"
    };
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>
#app {
  width: 750px;
}
.page {
  width: 690px;
  margin: 0 auto 100px auto;
}
.page-title {
  width: 100%;
  height: 50px;
  font-size: 36px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 50px;
  color: #333333;
  opacity: 1;
  text-align: center;
  margin: 30px auto 30px auto;
}
.page-desc {
  width: 100%;
  height: 44px;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 44px;
  color: #333333;
  opacity: 1;
  text-align: left;
  margin: 40px auto 30px auto;
}
.page-title-samll {
  width: 100%;
  height: 140px;
}
.page-title-samll p {
  font-size: 29px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 40px;
  color: #999999;
  opacity: 1;
  text-align: center;
}

.page img {
  width: 100%;
  height: auto;
}
.page-title-t{
  width: 100%;
  height: 88px;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 44px;
  color: #333333;
  opacity: 1;
  margin: 30px 0px 0px 0px;
}
.page-title-samll-t{
   width: 90%;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 34px;
  color: #999999;
  opacity: 1;
  text-align: center;
   margin: 30px auto 0px auto;
}
</style>


// WEBPACK FOOTER //
// src/components/clac/settingoppo.vue